import { render } from "./TicketPreview.vue?vue&type=template&id=260c5906&scoped=true"
import script from "./TicketPreview.vue?vue&type=script&lang=js"
export * from "./TicketPreview.vue?vue&type=script&lang=js"

import "./TicketPreview.vue?vue&type=style&index=0&id=260c5906&lang=scss&scoped=true"

import exportComponent from "Q:\\grdn-mr\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-260c5906"]])

export default __exports__